import config from '../config/app'
import axios from 'axios'
import Helper from '../helper/helper'
const updateAPI = {
  save (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/update',
        mimeType: 'multipart/form-data',
        data: Helper.getFormData(data)
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  update (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/update/save',
        mimeType: 'multipart/form-data',
        data: Helper.getFormData(data)
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  remove (updateId, data = []) {
    return new Promise((resolve, reject) => {
      axios.delete(config.server + '/update/' + updateId, {data: data}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getPartnerPendingDocument (userId) {
    let url = config.server + '/update/pending-document?user_id=' + userId

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getPartnerLastmonthUpdate (userId) {
    let url = config.server + '/update/last-month-update?user_id=' + userId

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getUpdatesByUserId (userId, additionalFields, filters) {
    let query = (additionalFields !== null && additionalFields !== undefined) ? '&additional=' + additionalFields.join(',') : ''
    let str = ''
    if (filters !== undefined) {
      str = Object.keys(filters).map(function (key) {
        return key + '=' + filters[key]
      }).join('&')
    }
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/update?user_id=' + userId + query + '&' + str).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getUpdatesById (userId, additionalFields, filters) {
    let query = (additionalFields !== null && additionalFields !== undefined) ? '&additional=' + additionalFields.join(',') : ''
    let str = ''
    if (filters !== undefined) {
      str = Object.keys(filters).map(function (key) {
        return key + '=' + filters[key]
      }).join('&')
    }
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/update?id=' + userId + query + '&' + str).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getUpdatesByPartner (option, additionalFields, filters) {
    let optionPath = (option !== null && option !== undefined && option !== 'all') ? '/' + option : ''
    let query = (additionalFields !== null && additionalFields !== undefined) ? 'additional=' + additionalFields.join(',') : ''
    let str = (additionalFields !== null && additionalFields !== undefined) ? '&' : ''
    if (filters !== undefined) {
      str += Object.keys(filters).map(function (key) {
        return key + '=' + filters[key]
      }).join('&')
    }
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/update' + optionPath + '?' + query + str).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getUpdatesByOption (option, additionalFields, filters) {
    let optionPath = (option !== null && option !== undefined && option !== 'all') ? '/' + option : ''
    let query = (additionalFields !== null && additionalFields !== undefined) ? 'additional=' + additionalFields.join(',') : ''
    let str = (additionalFields !== null && additionalFields !== undefined) ? '&' : ''
    if (filters !== undefined) {
      str += Object.keys(filters).map(function (key) {
        return key + '=' + filters[key]
      }).join('&')
    }
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/update' + optionPath + '?' + query + str).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getFavoriteUpdates (filters) {
    let str = ''
    if (filters !== undefined) {
      str += Object.keys(filters).map(function (key) {
        return key + '=' + filters[key]
      }).join('&')
    }
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/update/favorite?' + str).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  touchUpdate (updateId) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/update/like', {update_id: updateId}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}
export default updateAPI



// WEBPACK FOOTER //
// ./src/api/update.js